/**
 * The one sentence every store-catalogue import (Square Online, WooCommerce)
 * uses to say what a pasted URL resolved to — the whole shop, the common
 * single-brand case, or one category. Shared by the Test summary and the
 * Import Now toast so the two never disagree.
 */
export function storeScopeSummary(
  count: number,
  scope: 'shop' | 'category',
  categoryName?: string,
): string {
  const products = `${count} product${count === 1 ? '' : 's'}`;
  return scope === 'shop'
    ? `${products} across the whole shop`
    : `${products} in category “${categoryName ?? '?'}”`;
}

/**
 * The options part of a store load's summary: how many products were split
 * into one reference per option (variant expansion on), or how many products
 * with options import as a single reference each (expansion off).
 */
export function storeVariantSummary(loaded: {
  entries: unknown[];
  expandedProductCount: number;
  multiOptionCount: number;
}): string {
  if (loaded.expandedProductCount > 0) {
    return `; ${loaded.expandedProductCount} sold with options → ${loaded.entries.length} references (one per option)`;
  }
  if (loaded.multiOptionCount > 0) {
    return `; ${loaded.multiOptionCount} sold with options (each imports as one reference — variant expansion is off)`;
  }
  return '';
}
